import i18next from 'i18next';
import EAIcon from 'components/common/EAIcon';
import { theme } from 'style/globalStyle';

const EAEvolutionLineNotDataChart = () => {
  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '300px',
          border: '1.5px solid #FFF',
          borderRadius: '12px',
          background:'linear-gradient(113deg, rgba(255, 255, 255, 0.57) 0%, rgba(255, 255, 255, 0.56) 110.84%)',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <EAIcon
            icon="no-result"
            style={{
              fontSize: '48px',
              color: theme.palette.grey.grey400,
            }}
          />
          <div
            style={{
              fontSize: '18px',
              fontWeight: 600,
              textAlign: 'center',
              color: theme.palette.grey.grey400,
            }}
          >
            {i18next.t('companyNotScored')}
          </div>
        </div>
      </div>
    </div>
  );
};


export default EAEvolutionLineNotDataChart;
